var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/path.js
// module id = 551
// module chunks = 0